export const lclFormFields = {
  weight: "weight",
  MEASUREMENT: "measurement",
  WEIGHT_PRICE: "weightPrice",
  MEASUREMENT_PRICE: "measurementPrice",
  CHARGEABLE_WEIGHT: "chargeableWeight",
  CHARGEABLE_WEIGHT_PRICE: "chargeableWeightPrice",
  COMMENT: "comment",
  MIN_PRICE: "minPrice",
  MAX_PRICE: "maxPrice",
  BL_PRICE: "blPrice",
  SHIPMENT_PRICE: "shipmentPrice",
  PIECE_PRICE: "piecePrice",
  DOCUMENT_PRICE: "documentPrice",
  SHIPMENT_DISPLAY_UNIT_NAME: "shipmentDisplayUnitName",
};
